import { useState, useEffect } from "react";
import "./styles.css";
import Welcome from "./screens/Welcome";
import Login from "./auth/Login";
import Signup from "./auth/Signup";
import Dashboard from "./components/Dashboard/Dashboard";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { useAuth } from "./context/AuthContext";
import { PlanProvider } from "./context/PlanContext";
import { DashboardCustomizationProvider } from "./context/DashboardCustomizationContext"; // Added DashboardCustomizationProvider

function AppContent() {
  const [currentPage, setCurrentPage] = useState("welcome");
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      setCurrentPage("welcome");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const handleLoginSuccess = () => {
    // No need to manually set authentication state as Firebase handles it
  };

  const handleSignupSuccess = () => {
    setCurrentPage("signin");
  };

  return (
    <ThemeProvider>
      <div className="App">
        {user ? (
          <Dashboard onLogout={handleLogout} />
        ) : (
          <>
            {currentPage === "welcome" && (
              <Welcome
                onSignIn={() => setCurrentPage("signin")}
                onSignUp={() => setCurrentPage("signup")}
              />
            )}
            {currentPage === "signin" && (
              <Login
                onBackToWelcome={() => setCurrentPage("welcome")}
                onLoginSuccess={handleLoginSuccess}
              />
            )}
            {currentPage === "signup" && (
              <Signup
                onBackToWelcome={() => setCurrentPage("welcome")}
                onSignupSuccess={handleSignupSuccess}
              />
            )}
          </>
        )}
      </div>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <PlanProvider>
        <DashboardCustomizationProvider>
          <AppContent />
        </DashboardCustomizationProvider>
      </PlanProvider>
    </AuthProvider>
  );
}
